var map = {
	"./0.png": 33729,
	"./1.png": 812600,
	"./2.png": 608211,
	"./3.png": 876298,
	"./4.png": 946725,
	"./5.png": 710812,
	"./6.png": 418391,
	"./7.png": 235246,
	"./8.png": 508281,
	"./9.png": 502032,
	"./x.png": 77881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206524;